import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { company, services } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="inline-flex items-center bg-white rounded-lg px-3 py-2 shadow-md">
            <img
              src="https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/blob-cb4c291.png/:/rs=h:100,cg:true,m/qt=q:95"
              alt="Global Tech Solutions"
              className="h-12 w-auto object-contain"
            />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Your partner for IT, AV and Security solutions in Pune &mdash; delivered end-to-end with proven engineering excellence.
          </p>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold tracking-wide uppercase">
            Company
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold tracking-wide uppercase">
            Services
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            {services.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link
                  to="/services"
                  className="hover:text-white inline-flex items-center gap-1"
                >
                  {s.title}
                  <ArrowUpRight className="h-3.5 w-3.5 opacity-60" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold tracking-wide uppercase">
            Get in touch
          </h4>
          <ul className="mt-5 space-y-5 text-sm">
            <li>
              <div className="text-[11px] uppercase tracking-widest text-sky-400 font-semibold mb-1.5">Office</div>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-sky-400 shrink-0" />
                <span className="text-slate-400 leading-relaxed">{company.officeAddress}</span>
              </div>
            </li>
            <li>
              <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold mb-1.5">Registered</div>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-slate-500 shrink-0" />
                <span className="text-slate-400 leading-relaxed">{company.registeredAddress}</span>
              </div>
            </li>
            <li className="flex items-center gap-3 pt-2">
              <Phone className="h-4 w-4 text-sky-400" />
              <a href={`tel:${company.phone}`} className="hover:text-white">
                {company.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-sky-400" />
              <a href={`mailto:${company.email}`} className="hover:text-white">
                {company.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-slate-500 flex flex-col md:flex-row items-center justify-between gap-3">
          <span>
            © {new Date().getFullYear()} Global Tech Solutions. All rights reserved.
          </span>
          <span>Crafted with care in Pune, India</span>
        </div>
      </div>
    </footer>
  );
}
